import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import TetherContext from './TetherContext';

var TetherAnchor = /*#__PURE__*/function (_React$Component) {
  _inherits(TetherAnchor, _React$Component);

  var _super = _createSuper(TetherAnchor);

  function TetherAnchor() {
    _classCallCheck(this, TetherAnchor);

    return _super.apply(this, arguments);
  }

  _createClass(TetherAnchor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context != null) {
        var registerAnchor = this.context.registerAnchor;
        registerAnchor(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.context != null) {
        var unregisterAnchor = this.context.unregisterAnchor;
        unregisterAnchor();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.Children.only(children);
    }
  }]);

  return TetherAnchor;
}(React.Component);

_defineProperty(TetherAnchor, "displayName", 'TetherAnchor');

_defineProperty(TetherAnchor, "contextType", TetherContext);

export default TetherAnchor;